var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"color":_vm.toolbarColor,"dense":"","elevation":"1"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-file-document-multiple")]),_c('v-toolbar-title',[_vm._v("My Applications ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }